import { render } from "./TriggersPage.vue?vue&type=template&id=328929eb&scoped=true&ts=true"
import script from "./TriggersPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TriggersPage.vue?vue&type=script&lang=ts&setup=true"

import "./TriggersPage.vue?vue&type=style&index=0&id=328929eb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328929eb"],['__file',"src/pages/settings/pages/triggers/TriggersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "328929eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('328929eb', __exports__)) {
    api.reload('328929eb', __exports__)
  }
  
  module.hot.accept("./TriggersPage.vue?vue&type=template&id=328929eb&scoped=true&ts=true", () => {
    api.rerender('328929eb', render)
  })

}


export default __exports__